import React from 'react';

function ProgressCircleLarge(props: any) {
    const count: number = props.count ? props.count : 0;
    const total: number  = props.total ? props.total : 0;
    const content = (
        <div className="circle">
            <span className="small-number">{count}</span><span className="slash">/</span><span className="number font-weight-bold">{total}</span>
        </div>

    );
    const percent = Math.round(count * 100 / total);
    if (percent <= 50) {
        const degValue = 180 * (percent / 50) + 90;
        return (
            <div className="active-border" style={{ backgroundColor: 'rgb(200,200,200)', backgroundImage: 'linear-gradient(to right, rgb(200, 200, 200) 50%, transparent 50%, transparent), linear-gradient(' + degValue + 'deg, #28a745 50%, rgb(200,200,200) 50%, rgb(200,200,200))' }}>
                {content}
            </div>
        );
    } else {
        const degValue = 180 * ((percent - 50) / 50) - 90;
        return (
            <div className="active-border" style={{ backgroundColor: 'rgb(200,200,200)', backgroundImage: 'linear-gradient(' + degValue + 'deg, #28a745 50%, transparent 50%, transparent), linear-gradient(to left, #28a745 50%, rgb(200,200,200) 50%)' }}>
                {content}
            </div>
        );
    }
}

export default ProgressCircleLarge;
